import { FC } from 'react'
import { SvgProps } from './svgProps'

const FilterIconRedesign: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    width={width || '14'}
    height={height || '15'}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_512_1178)">
      <path
        d="M1.16663 12.1667C1.16663 11.8445 1.4278 11.5833 1.74996 11.5833H5.83329C6.15547 11.5833 6.41663 11.8445 6.41663 12.1667C6.41663 12.4889 6.15547 12.75 5.83329 12.75H1.74996C1.4278 12.75 1.16663 12.4889 1.16663 12.1667Z"
        fill={color || '#222222'}
      />
      <path
        d="M8.75004 11.5833V10.4167C8.75004 10.0945 8.48888 9.83334 8.16671 9.83334C7.84453 9.83334 7.58337 10.0945 7.58337 10.4167V13.9167C7.58337 14.2389 7.84453 14.5 8.16671 14.5C8.48888 14.5 8.75004 14.2389 8.75004 13.9167V12.75H12.25C12.5722 12.75 12.8334 12.4889 12.8334 12.1667C12.8334 11.8445 12.5722 11.5833 12.25 11.5833H8.75004Z"
        fill={color || '#222222'}
      />
      <path
        d="M6.99996 6.91666C6.67778 6.91666 6.41663 7.17781 6.41663 7.49999C6.41663 7.82216 6.67778 8.08332 6.99996 8.08332H12.25C12.5721 8.08332 12.8333 7.82216 12.8333 7.49999C12.8333 7.17781 12.5721 6.91666 12.25 6.91666H6.99996Z"
        fill={color || '#222222'}
      />
      <path
        d="M1.16663 7.49999C1.16663 7.17781 1.4278 6.91666 1.74996 6.91666H4.08329V5.74999C4.08329 5.42783 4.34446 5.16666 4.66663 5.16666C4.98879 5.16666 5.24996 5.42783 5.24996 5.74999V9.24999C5.24996 9.57216 4.98879 9.83332 4.66663 9.83332C4.34446 9.83332 4.08329 9.57216 4.08329 9.24999V8.08332H1.74996C1.4278 8.08332 1.16663 7.82216 1.16663 7.49999Z"
        fill={color || '#222222'}
      />
      <path
        d="M8.75004 2.25V1.08333C8.75004 0.761168 8.48888 0.5 8.16671 0.5C7.84453 0.5 7.58337 0.761168 7.58337 1.08333V4.58333C7.58337 4.9055 7.84453 5.16667 8.16671 5.16667C8.48888 5.16667 8.75004 4.9055 8.75004 4.58333V3.41667H12.25C12.5722 3.41667 12.8334 3.1555 12.8334 2.83333C12.8334 2.51117 12.5722 2.25 12.25 2.25H8.75004Z"
        fill={color || '#222222'}
      />
      <path
        d="M1.16663 2.83333C1.16663 3.1555 1.4278 3.41667 1.74996 3.41667H5.83329C6.15547 3.41667 6.41663 3.1555 6.41663 2.83333C6.41663 2.51117 6.15547 2.25 5.83329 2.25H1.74996C1.4278 2.25 1.16663 2.51117 1.16663 2.83333Z"
        fill={color || '#222222'}
      />
    </g>
    <defs>
      <clipPath id="clip0_512_1178">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default FilterIconRedesign
